import type { ReactNode } from 'react'
import { SiteFooter } from '../layout/site-footer'
import { SiteHeader } from '../layout/site-header'

export interface PageShellProps {
  children: ReactNode
  className?: string
  title?: string
}

export function PageShell({ children, className }: Readonly<PageShellProps>) {
  return (
    <div className={['autoglow-home page-shell', className].filter(Boolean).join(' ')}>
      <SiteHeader />
      <main id="main">{children}</main>
      <SiteFooter />
    </div>
  )
}
